import React, { Component } from 'react';
import { List } from "antd";

import MessageItem from '../../Items/MessageItem';

class ContactList extends Component {
  state = {
    allChats: [],
    getInitialChats: false
  }

  static getDerivedStateFromProps(props, state) {
    const { allChats } = props;
    
    if (allChats !== state.allChats) {
      return {
        allChats: allChats,
        getInitialChats: true
      };
    }

    return null;
  }

  render() {
    const { 
      params, 
      uid, 
      handleChatChange, 
      search, 
      safeTofavoriteSwitcher,
      favoriteChats,
      viewType
    } = this.props;

    const filteredContactList = this.state.allChats.filter(chatInfo => {
      const DisplayName = chatInfo.companionData.DisplayName.toLowerCase();
      const searchByName = DisplayName.indexOf(search) !== -1;
      
      let serachByContent = false;
      chatInfo.chat.forEach(chatItem => {
        const message = chatItem.message.toLowerCase();
        const deleted = chatItem.deleted;
        if (message.indexOf(search) !== -1 && !deleted) {
          serachByContent = true;
        }
      });

      return searchByName || serachByContent;
    }).filter(function(chatInfo) {
      if (viewType === 'favorite') {
        return this.indexOf(chatInfo.chatId) >= 0
      }

      return chatInfo;
    }, favoriteChats);

    return (
      <List
        className="chat"
        itemLayout="horizontal"
        dataSource={filteredContactList}
        split={false}
        renderItem={chatData => {
          const sortedChats = chatData.chat.sort((a,b) => new Date(a.date) - new Date(b.date));

          const lastIndex = sortedChats && sortedChats.length - 1;
          const lastMessage = sortedChats && sortedChats.length > 1 ?
            (
              !sortedChats[lastIndex].deleted ? sortedChats[lastIndex].message : 'Message deleted'
            ) : 'First Message';

          const lastMessageDate = sortedChats && sortedChats.length > 1 ?
            sortedChats[lastIndex].date : new Date();

          const isChatFavorite = favoriteChats.indexOf(chatData.chatId) !== -1;
          
          // const lastIndex = chatData.chat && chatData.chat.length - 1;
          // const lastMessage = chatData.chat && chatData.chat.length > 1 ?
          //   chatData.chat[lastIndex].message : 'First Message';

          // const lastMessageDate = chatData.chat && chatData.chat.length > 1 ?
          //   chatData.chat[lastIndex].date : new Date();

          return <MessageItem 
            chatData={chatData}
            handleChatChange={handleChatChange}
            lastMessage={lastMessage}
            lastMessageDate={lastMessageDate}
            paramsId={params.id}
            uid={uid}
            safeTofavoriteSwitcher={safeTofavoriteSwitcher}
            isChatFavorite={isChatFavorite}
          />
        }}
      />
    )
  }
}

export default ContactList;


// WEBPACK FOOTER //
// ./src/components/Modules/ContactList/index.js